import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import * as publicacionesService from '../servicios/publicacionesTemporalesService'
import InputLabel from '../ui/InputLabel'
import LinkButton from '../ui/LinkButton'
import Select from '../ui/Select'
import PrecioRango from './PrecioRango'

const IndicarPrecio = ({ values, onChange, onChangeState }) => {
  const [monedas, setMonedas] = useState([])
  const [unidades, setUnidades] = useState([])

  useEffect(() => {
    const obtenerDatos = async () => {
      const monedasRtn = await publicacionesService.buscarMoneda()
      setMonedas(monedasRtn.data)

      const unidadesRtn = await publicacionesService.buscarUnidad()
      setUnidades(unidadesRtn.data)
    }

    obtenerDatos()
  }, [])

  const handleTipoPrecio = function (e) {
    onChangeState('conStock', e.target.value === '1')
    onChangeState('conStockAPedido', e.target.value === '2')
    onChangeState('conPresupuesto', e.target.value === '3')
  }

  const handleAgregarPrecio = (e) => {
    e.preventDefault()
    const idUnidadMedida =
      values.preciosMayorista.length === 0 ? 0 : values.preciosMayorista[0].idUnidadMedida

    onChangeState('preciosMayorista', [
      ...values.preciosMayorista,
      {
        cantidad: 0,
        idUnidadMedida: idUnidadMedida,
        precio: 0,
        id: values.preciosMayorista.length
      }
    ])
  }

  const handleEliminarPrecio = (id) => {
    const restantes = values.preciosMayorista
      .filter((p) => p.id !== id)
      .map((p, indice) => ({ ...p, id: indice }))

    onChangeState('preciosMayorista', restantes)
  }

  const handleChangeRango = ({ currentTarget }, id) => {
    const clon = [...values.preciosMayorista]
    const indice = clon.findIndex((p) => p.id === id)
    clon[indice] = {
      ...clon[indice],
      [currentTarget.name]: Number(currentTarget.value),
      id: id
    }
    onChangeState('preciosMayorista', clon)
  }

  return (
    <>
      <p className="descripcion-cuadro-publicacion precio-form-descripcion">
        Indicá el precio y stock de tu producto.
      </p>
      <div className="precio-form-tipos">
        <label htmlFor="conStock">
          <Checkbox
            name="conStock"
            type="checkbox"
            value="1"
            checked={values.conStock}
            onChange={handleTipoPrecio}
          />
          <span>Con Stock</span>
        </label>
        <label htmlFor="conStockAPedido">
          <Checkbox
            name="conStockAPedido"
            type="checkbox"
            value="2"
            checked={values.conStockAPedido}
            onChange={handleTipoPrecio}
          />
          <span>A Pedido</span>
        </label>
        <label htmlFor="conPresupuesto">
          <Checkbox
            name="conPresupuesto"
            type="checkbox"
            value="3"
            checked={values.conPresupuesto}
            onChange={handleTipoPrecio}
          />
          <span>Presupuesto</span>
        </label>
      </div>

      {(values.conStock || values.conStockAPedido) && (
        <div className="precio-form-columnas">
          <div className="precio-form-minorista">
            <p className="precio-form-subtitulo">Precio Minorista</p>
            <div className="precio-form-grid">
              {values.conStock && (
                <InputLabel
                  type="number"
                  name="cantDisponible"
                  value={values.cantDisponible}
                  onChange={(e) => onChange(e, 'num')}
                  label="Cantidad Disponible:"
                  classNameContainer="precio-campo"
                  error="Completar Cantidad Disponible"
                  onFocusSelected
                />
              )}

              <div className="precio-campo">
                <label htmlFor="idMoneda">Moneda:</label>
                <div className="precio-campo-control">
                  <Select
                    name="idMoneda"
                    onChange={(e) => onChange(e, 'num')}
                    datos={monedas}
                    optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
                    optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
                    value={values.idMoneda}
                  />
                </div>
              </div>

              {values.conStockAPedido && (
                <>
                  <InputLabel
                    type="number"
                    name="cantMinPedido"
                    value={values.cantMinPedido}
                    onChange={(e) => onChange(e, 'num')}
                    label="Cantidad Mínima de Pedido:"
                    classNameContainer="precio-campo"
                    error="Completar Cantidad Mínima de Pedido"
                    onFocusSelected
                  />

                  <InputLabel
                    type="number"
                    name="capacidadMax"
                    value={values.capacidadMax}
                    onChange={(e) => onChange(e, 'num')}
                    label="Capacidad Máxima:"
                    classNameContainer="precio-campo"
                    error="Completar Capacidad Máxima"
                    onFocusSelected
                  />

                  <div className="precio-campo">
                    <label htmlFor="tipoProducionCant">Tiempo de Producción:</label>
                    <div className="precio-produccion">
                      <input
                        type="number"
                        name="tipoProducionCant"
                        id="tipoProducionCant"
                        required
                        onChange={(e) => onChange(e, 'num')}
                        value={values.tipoProducionCant}
                      />
                      <select
                        name="tipoProducionUnidad"
                        id="tipoProducionUnidad"
                        required
                        onChange={(e) => onChange(e, 'num')}
                        value={values.tipoProducionUnidad}
                      >
                        <option value="0">Elegir</option>
                        <option value="1">hora</option>
                        <option value="2">día</option>
                        <option value="3">semana</option>
                        <option value="4">mes</option>
                        <option value="5">año</option>
                      </select>
                    </div>
                  </div>
                </>
              )}

              <InputLabel
                type="number"
                name="precioUnitario"
                value={values.precioUnitario}
                onChange={(e) => onChange(e, 'num')}
                label={
                  <>
                    Precio Minorista ($)&nbsp;
                    <i className="fa fa-usd" aria-hidden="true" />
                  </>
                }
                classNameContainer="precio-campo"
                error="Completar Precio Minorista"
                onFocusSelected
              />

              <InputLabel
                type="number"
                name="alicuota"
                value={values.alicuota}
                onChange={(e) => onChange(e, 'num')}
                label={
                  <>
                    Alícuota&nbsp;
                    <i className="fa fa-percent" aria-hidden="true" />
                  </>
                }
                classNameContainer="precio-campo"
                error="Completar Alícuota"
                onFocusSelected
                step="0.1"
              />
            </div>

            <div className="precio-form-mayorista">
              <p className="precio-form-subtitulo">Precio Mayorista</p>
              {values.preciosMayorista.map((rango, index) => (
                <PrecioRango
                  key={index}
                  id={index}
                  values={rango}
                  unidades={unidades}
                  onChange={(e) => handleChangeRango(e, index)}
                  onEliminar={
                    values.preciosMayorista.length > 1
                      ? () => handleEliminarPrecio(index)
                      : undefined
                  }
                />
              ))}
              <div className="precio-agregar-rango">
                <LinkButton className="precio-agregar-rango-btn" onClick={handleAgregarPrecio}>
                  <i className="fa fa-plus" aria-hidden="true" />
                </LinkButton>
              </div>
            </div>
          </div>
        </div>
      )}

      {values.conPresupuesto && (
        <div className="precio-form-grid">
          <div className="precio-campo">
            <label htmlFor="idMoneda">Moneda:</label>
            <div className="precio-campo-control">
              <Select
                name="idMoneda"
                onChange={(e) => onChange(e, 'num')}
                datos={monedas}
                optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
                optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
                value={values.idMoneda}
              />
            </div>
          </div>

          <InputLabel
            type="number"
            name="alicuota"
            value={values.alicuota}
            onChange={(e) => onChange(e, 'num')}
            label="Alícuota (%):"
            classNameContainer="precio-campo"
            error="Completar Alícuota"
            onFocusSelected
            step="0.1"
          />
        </div>
      )}
    </>
  )
}

IndicarPrecio.propTypes = {
  values: PropTypes.shape({
    conStock: PropTypes.bool,
    conStockAPedido: PropTypes.bool,
    conPresupuesto: PropTypes.bool,
    cantDisponible: PropTypes.number,
    cantMinPedido: PropTypes.number,
    capacidadMax: PropTypes.number,
    idMoneda: PropTypes.number,
    precioUnitario: PropTypes.number,
    alicuota: PropTypes.number,
    tipoProducionCant: PropTypes.number,
    tipoProducionUnidad: PropTypes.number,
    preciosMayorista: PropTypes.arrayOf(
      PropTypes.shape({
        cantidad: PropTypes.number,
        idUnidadMedida: PropTypes.number,
        precio: PropTypes.number,
        id: PropTypes.number
      })
    )
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeState: PropTypes.func.isRequired
}

export default IndicarPrecio
